// StateContainer.jsx
import React from "react";

const StatusCard = ({ StatusName, StatusNumber }) => {
  return (
    <div className="flex flex-col justify-center items-center py-2 px-4 h-24 bg-background rounded-xl text-center gap-2">
      <h2 className="lg:text-headline4 !text-secondary/90 text-subtitle2 font-bold font-nunito">
        {StatusNumber}
      </h2>

      <p className="lg:text-subtitle2 text-body2 font-ptsans font-medium text-secondary/75">
        {StatusName}
      </p>
    </div>
  );
};

const StatsContainer = ({ status, label, lgCols = 5 }) => {
  return (
    <div className="flex flex-col gap-4 bg-background_2/80 p-4 rounded-3xl  h-fit w-full">
      <h1 className="md:text-headline4 text-subtitle1 font-bold font-nunito text-secondary/90">
        {label}
      </h1>
      <div
        className={`grid grid-cols-2 md:grid-cols-3 ${
          lgCols === 4 ? "lg:grid-cols-4" : "lg:grid-cols-5"
        } gap-2 justify-between`}
      >
        {status.map((state, index) => (
          <StatusCard
            key={index}
            StatusName={state.statusName} // Use 'statusName' from the data
            StatusNumber={state.statusNumber} // Use 'statusNumber' from the data
          />
        ))}
      </div>
    </div>
  );
};

export default StatsContainer;
